<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-message__messagetemplate">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.templateTitle" placeholder="模版标题" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.templateType" placeholder="模版类型" clearable>
            <el-option label="短信" :value="messageType.SMS"></el-option>
            <el-option label="微信" :value="messageType.WE_CHAT"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.schoolName" placeholder="学校名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('message:template:save')" type="primary" @click="addOrUpdateHandle()">
            {{ $t('add') }}
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('message:template:delete')" type="danger" @click="deleteHandle()">
            {{ $t('deleteBatch') }}
          </el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle"
                style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="templateTitle" label="模版标题" header-align="center" align="center"></el-table-column>
        <el-table-column prop="templateType" label="模版类型" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" type="success" v-if="scope.row.templateType===messageType.WE_CHAT">微信</el-tag>
            <el-tag size="mini" type="success" v-if="scope.row.templateType===messageType.SMS">短信</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="schoolName" label="学校名" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('message:template:update')" type="text" size="small"
                       @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}
            </el-button>
            <el-button v-if="$hasPermission('message:template:delete')" type="text" size="small"
                       @click="deleteHandle(scope.row.id)">{{ $t('delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './message-template-add-or-update'
import { messageType } from '@/constant'

export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/message/template/page',
        getDataListIsPage: true,
        deleteURL: '/message/template',
        deleteIsBatch: true
      },
      messageType,
      dataForm: {
        templateTitle: '',
        templateType: ''
      }
    }
  },
  watch: {},
  components: {
    AddOrUpdate
  }
}
</script>
